(function () {
  'use strict';

  const SECTION_SELECTOR =
    '.cc-section.cc-blog-newsletter';

  const FORM_SELECTOR =
    '[data-newsletter-form]';

  const SUCCESS_SELECTOR =
    '[data-newsletter-success]';

  const EMAIL_SELECTOR =
    '.klaviyo-emailinput input[type="email"]';

  const FORM_FIELDS_SELECTOR = [
    '.klaviyo-emailinput input[type="email"]',
    '.klaviyo-form-button'
  ].join(', ');

  /**
   * Updates the Klaviyo email input placeholder
   * and accessibility label.
   *
   * @param {HTMLElement} section
   */
  function configureKlaviyoForm(section) {
    if (!section) return;

    const formContainer =
      section.querySelector(FORM_SELECTOR);

    if (!formContainer) return;

    const emailInput =
      formContainer.querySelector(EMAIL_SELECTOR);

    if (!emailInput) return;

    emailInput.placeholder = 'Your email address';

    emailInput.setAttribute(
      'aria-label',
      'Your email address'
    );
  }

  /**
   * Checks whether the Klaviyo email field or
   * Subscribe button is currently present.
   *
   * @param {HTMLElement} formContainer
   * @returns {boolean}
   */
  function hasKlaviyoFormFields(formContainer) {
    if (!formContainer) return false;

    return Boolean(
      formContainer.querySelector(
        FORM_FIELDS_SELECTOR
      )
    );
  }

  /**
   * Hides the submitted form and displays the
   * custom successful-subscription message.
   *
   * @param {HTMLElement} formContainer
   * @param {HTMLElement} successMessage
   */
  function showSuccessMessage(
    formContainer,
    successMessage
  ) {
    if (!formContainer || !successMessage) return;

    formContainer.hidden = true;

    formContainer.setAttribute(
      'aria-hidden',
      'true'
    );

    successMessage.hidden = false;
  }

  /**
   * Watches a newsletter section because Klaviyo
   * injects and updates its form asynchronously.
   *
   * @param {HTMLElement} section
   */
  function initializeNewsletterSection(section) {
    if (
      !section ||
      section.dataset.newsletterInitialized ===
        'true'
    ) {
      return;
    }

    const formContainer =
      section.querySelector(FORM_SELECTOR);

    const successMessage =
      section.querySelector(SUCCESS_SELECTOR);

    if (!formContainer) return;

    section.dataset.newsletterInitialized = 'true';

    let hadVisibleForm = false;
    let successShown = false;
    let successTimer = null;

    /**
     * Updates the form and checks whether Klaviyo
     * has replaced it after successful submission.
     */
    function checkFormState() {
      configureKlaviyoForm(section);

      const hasFormFields =
        hasKlaviyoFormFields(formContainer);

      /*
       * Klaviyo has finished injecting the form.
       */
      if (hasFormFields) {
        hadVisibleForm = true;

        if (successTimer) {
          window.clearTimeout(successTimer);
          successTimer = null;
        }

        return;
      }

      /*
       * Do not show the success message while the
       * Klaviyo form is still initially loading.
       */
      if (
        !hadVisibleForm ||
        successShown ||
        !successMessage
      ) {
        return;
      }

      /*
       * Wait briefly and check again to prevent a
       * temporary Klaviyo re-render from being
       * treated as a successful submission.
       */
      if (successTimer) {
        window.clearTimeout(successTimer);
      }

      successTimer = window.setTimeout(
        function () {
          successTimer = null;

          if (
            hasKlaviyoFormFields(formContainer)
          ) {
            return;
          }

          successShown = true;

          showSuccessMessage(
            formContainer,
            successMessage
          );
        },
        300
      );
    }

    checkFormState();

    const observer = new MutationObserver(
      function () {
        checkFormState();
      }
    );

    observer.observe(formContainer, {
      childList: true,
      subtree: true
    });
  }

  /**
   * Initializes every newsletter section within
   * the provided container.
   *
   * @param {Document|HTMLElement} container
   */
  function initializeNewsletterSections(
    container
  ) {
    const scope = container || document;
    const sections = [];

    if (
      scope.matches &&
      scope.matches(SECTION_SELECTOR)
    ) {
      sections.push(scope);
    }

    if (scope.querySelectorAll) {
      scope
        .querySelectorAll(SECTION_SELECTOR)
        .forEach(function (section) {
          sections.push(section);
        });
    }

    sections.forEach(function (section) {
      initializeNewsletterSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initializeNewsletterSections(document);
      }
    );
  } else {
    initializeNewsletterSections(document);
  }

  /*
   * Reinitialize when Shopify reloads the section
   * inside the Theme Editor.
   */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initializeNewsletterSections(event.target);
    }
  );
})();